import Lottie from 'lottie-react';
import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import { Button, Col, Row } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import celebration from './lottie/celebration.json';

function Success({ reset, setUser }) {
  const navigate = useNavigate();
  const emptyData = () => {
    setUser({});
    reset();
    navigate('/#');
  };

  useEffect(() => window.localStorage.removeItem('logica_data'), []);

  return (
    <Row>
      <Col className="text-center">
        <div className="wizard-lottie-wrapper">
          <div className="wizard-lottie mx-auto">
            <Lottie animationData={celebration} loop />
          </div>
        </div>
        <h4 className="mb-1">Ваш обліковий запис створено!</h4>
        <p className="fs-0">Перевірте вашу ел.адресу. Ми надіслали вам запрошення на встановлення паролю. За допомогою встановленного паролю, ви матимете доступ до "Є-Пічник".</p>
        <p> Запрошення має обмежений термін дії!</p>
        <Button color="primary" className="px-5 my-3" onClick={emptyData}>
          Початкова сторінка
        </Button>
      </Col>
    </Row>
  );
}

Success.propTypes = {
  reset: PropTypes.func.isRequired,
  setUser: PropTypes.func.isRequired,
};

export default Success;
